
const Helper = {

    AddTicksToUrl: (url: string, date : string) => {

        let ticks = (new Date(date)).getTime();

        let append= '?';
        if (url.includes('?')) {
            append = '&';
        } 

        return url + append + 't=' + ticks;
        
    }

}

export default Helper;